import { render, staticRenderFns } from "./ProductImages.vue?vue&type=template&id=36657f9c"
import script from "./ProductImages.vue?vue&type=script&lang=js"
export * from "./ProductImages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports